import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {
    chargeUrl,
    coordinatorsUrl, departmentsUrl,
    filesUrl, formatsActiveUrl, formatsUrl,
    groupsAllUrl, importanceUrl, locationsActiveUrl,
    locationsUrl,
    namesUrl, projectsActiveUrl, projectsUrl, purposesUrl,
    reposUrl,
    rolesUrl,
    storageUrl, worktypesActiveUrl, worktypesUrl
} from '../api-url';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
respMsg: any = {};
tempUrl = '/api/admin/tempr';
  constructor(private http: HttpClient, private router: Router) { }
  getGroups() {
    return this.http.get<any[]>(groupsAllUrl);
  }
  getNames() {
    return this.http.get<any[]>(namesUrl);
  }
  getCoordinators() {
    return this.http.get<any[]>(coordinatorsUrl);
  }
  getRepos() {
    return this.http.get<any[]>(reposUrl);
  }
  getLocations() {
    return this.http.get<any[]>(locationsUrl);
  }
  getChargeto() {
    return this.http.get<any[]>(chargeUrl);
  }
  getRoles() {
    return this.http.get<any[]>(rolesUrl);
  }
  getStorage() {
    return this.http.get<any[]>(storageUrl);
  }
  getFilesByPerson(id) {
    return this.http.get<any[]>(`${filesUrl}/` + id);
  }
  // DEPARTMENTS
  getDepartments() {
    return this.http.get<any[]>(departmentsUrl);
  }
  createDepartment(department) {
    this.http
      .post(`${departmentsUrl}/`, department)
      .subscribe(response => {
        console.log('CREATED DEPT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updateDepartment(departmentId, department) {
    this.http
      .put(`${departmentsUrl}/${departmentId}`, department)
      .subscribe(response => {
        console.log('UPDATED DEPT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deleteDepartment(departmentId) {
    this.http.delete(`${departmentsUrl}/${departmentId}`)
      .subscribe((response) => {
        console.log('DEL DEPT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  // FORMATS
  getActiveFormats() {
    return this.http.get<any[]>(formatsActiveUrl);
  }
  getAllFormats() {
    return this.http.get<any[]>(formatsUrl);
  }
  createFormat(format) {
    this.http
      .post(`${formatsUrl}/`, format)
      .subscribe(response => {
        console.log('CREATED FORMAT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updateFormat(formatId, format) {
    this.http
      .put(`${formatsUrl}/${formatId}`, format)
      .subscribe(response => {
        console.log('UPDATED FORMAT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deleteFormat(formatId) {
    this.http.delete(`${formatsUrl}/${formatId}`)
      .subscribe((response) => {
        console.log('DEL FORMAT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  // IMPORTANCE
  getImportance() {
    return this.http.get<any[]>(importanceUrl);
  }
  createImportance(importance) {
    this.http
      .post(`${importanceUrl}/`,  importance)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updateImportance(importanceId, importance) {
    this.http
      .put(`${importanceUrl}/${importanceId}`, importance)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deleteImportance(importanceId) {
    this.http.delete(`${importanceUrl}/${importanceId}`)
      .subscribe((response) => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  // LOCATIONS
  getAllLocations() {
    return this.http.get<any[]>(locationsUrl);
  }
  getActiveLocations() {
    return this.http.get<any[]>(locationsActiveUrl);
  }
  createLocation(location) {
    this.http
      .post(`${locationsUrl}/`, location)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updateLocation(locationId, location) {
    this.http
      .put(`${locationsUrl}/${locationId}`, location)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deleteLocation(locationId) {
    this.http.delete(`${locationsUrl}/${locationId}`)
      .subscribe((response) => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  // PROJECTS
  getActiveProjects() {
    return this.http.get<any[]>(projectsActiveUrl);
  }
  getAllProjects() {
    return this.http.get<any[]>(projectsUrl);
  }
  createProject(project) {
    this.http
      .post(`${projectsUrl}/`,  project)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updateProject(projectId, project) {
    this.http
      .put(`${projectsUrl}/${projectId}`, project)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deleteProject(projectId) {
    this.http.delete(`${projectsUrl}/${projectId}`)
      .subscribe((response) => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  // PURPOSES
  getPurposes() {
    return this.http.get<any[]>(purposesUrl);
  }
  createPurpose(purpose) {
    this.http
      .post(`${purposesUrl}/`,  purpose)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updatePurpose(purposeId, purpose) {
    this.http
      .put(`${purposesUrl}/${purposeId}`, purpose)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deletePurpose(purposeId) {
    this.http.delete(`${purposesUrl}/${purposeId}`)
      .subscribe((response) => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  // WORK TYPES
  getActiveWorkTypes() {
    return this.http.get<any[]>(worktypesActiveUrl);
  }
  getAllWorkTypes() {
    return this.http.get<any[]>(worktypesUrl);
  }
  createWorkType(wtype) {
    this.http
      .post(`${worktypesUrl}/`, wtype)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  updateWorkType(workTypeId, wtype) {
    this.http
      .put(`${worktypesUrl}/${workTypeId}`, wtype)
      .subscribe(response => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
  deleteWorkType(workTypeId) {
    this.http.delete(`${worktypesUrl}/${workTypeId}`)
      .subscribe((response) => {
        this.respMsg = response;
        this.router.navigate([this.tempUrl]);
      });
  }
}// end service
